import {
	Component,
	ChangeDetectorRef,
	EventEmitter,
	Output,
	ChangeDetectionStrategy
} from '@angular/core';
import { AuthService } from '../../shared/auth-service';
import { CountryList } from '../translate/translations';
import { Country } from './country';
import { EventEmitterService } from '../../api/event.service';

@Component({
    selector: 'hb-country-list',
    templateUrl: './country.component.html',
    styleUrls: ['./country.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CountryComponent {
	get lang() {
		let urlLang = window.location.pathname.split('/')[2];

		let country = CountryList.find((country) => country.key === urlLang);
		if (country) {
			this.countryNameS = country.name;
			return country.name;
		}
		else {
			this.countryNameS = 'en';
			return 'en';
		}
	}

	@Output() parentComponent = new EventEmitter<string>();

	private countryName: string = 'countryName';
	private countryKey: string = 'countryKey';
	public countryNameS: string;
	public isOpen: boolean;
	// = localStorage.getItem(this.countryName) || 'A002German';
	countries: any;

	constructor(
		private authService: AuthService,
		private triggerService: EventEmitterService,
		private cd: ChangeDetectorRef
	) {
		this.countries = this.getPermittedLanguageOptionsForUser();
		this.countryNameS = this.countries.find((country) => country.key === window.location.pathname.split('/')[2]).name;
	}

	public countrySelect(country: Country) {
		this.toggle();
		this.countryNameS = country.name;
		this.cd.markForCheck();
		localStorage.setItem(this.countryName, country.name);
		localStorage.setItem(this.countryKey, country.key);

		// triggers charts
		this.triggerService.langtrigger.next(country.key);
		this.parentComponent.emit(country.key);
	}

	private getPermittedLanguageOptionsForUser() {
		const user = this.authService.userSnapshot;
		if (
			user &&
			user.hasRole('ADMIN') &&
			this.isPrivilegedCompany(user.parentId)
		) {
			return CountryList; // all language options are available for privileged company's admin users.
		}
		return CountryList.filter((x) => x.key !== 'ml').filter(
			(x) => x.key !== 'key'
		);
	}

	/**
	 * @param companyId id of the company.
	 *
	 * companyId is null for a Blu-pa user.
	 * companyId is 1 for a Haver & Boecker user.
	 */
	private isPrivilegedCompany(companyId: number) {
		return companyId === null || companyId === 1;
	}

	public toggle() {
		this.isOpen = !this.isOpen;
	}
}
